import $ from 'jquery'

export class CalculatorSickLeave {

  constructor() {
    this.$container = $('.calculator-sick-leave')

    if (!this.$container.length) return

    this.$form = this.$container.find('form')
    this.$inputs = this.$form.find('input')
    this.$containerWithResult = this.$container.find('.with-results')
    this.$containerWithoutResult = this.$container.find('.no-result')
    this.$feeInput = this.$container.find('#sickleave-fee')
    this.$baseInput = this.$container.find('#sickleave-base')
    this.$daysInput = this.$container.find('#sickleave-days')

    // read limits and rates from data attributes (set in Twig via ACF)
    const baseMinAttr = this.$container.attr('data-base-min')
    const baseMaxAttr = this.$container.attr('data-base-max')
    const parsedMin = parseFloat(baseMinAttr)
    const parsedMax = parseFloat(baseMaxAttr)
    this.baseLimits = {
      min: Number.isFinite(parsedMin) ? parsedMin : 950.98,
      max: Number.isFinite(parsedMax) ? parsedMax : 4720.5
    }

    const rate = parseFloat(this.$container.attr('data-rate'))
    const tier1End = parseInt(this.$container.attr('data-tier1-end'), 10)
    const maxMonthsFee = parseInt(this.$container.attr('data-max-months-fee'), 10)

    this.rate = Number.isFinite(rate) ? rate / 100 : 0.75
    this.tier1End = Number.isFinite(tier1End) ? tier1End : 1
    this.maxMonthsFee = Number.isFinite(maxMonthsFee) ? maxMonthsFee : 2

    this.$monthlyAmount = this.$container.find('#sickleave-text-contribution')
    this.$benefitMonths = this.$container.find('#sickleave-text-month')
    this.$netAmount = this.$container.find('#sickleave-text-net')
    this.$error = this.$container.find('.calc-error')

    // detail lines
    this.$details = this.$container.find('#sickleave-details')
    this.$line1 = this.$container.find('#sickleave-line-1')
    this.$line2 = this.$container.find('#sickleave-line-2')
    this.$lineTotal = this.$container.find('#sickleave-line-total')

    this.$form.on('change', this.handleChangeForm.bind(this))
    this.$form.on('input', this.handleSubmitForm.bind(this))
    this.$inputs.on('keyup', this.handleChangeForm.bind(this))

    // run calculation on load with default values
    this.handleChangeForm()
  }

  handleSubmitForm(e) {
    e.preventDefault()
    this.handleChangeForm()
  }

  handleChangeForm() {
    this.$containerWithResult.show()
    this.$containerWithoutResult.hide()

    let monthlyFee = this.toFloat(this.$feeInput.val())
    let monthlyBase = this.toFloat(this.$baseInput.val())
    let leaveDays = this.toInt(this.$daysInput.val())

    const minAllowed = this.baseLimits.min
    const maxAllowed = this.baseLimits.max
    if (monthlyBase > maxAllowed || monthlyBase < minAllowed) {
      this.$error.show()
      this.$details.hide()

      this.applyValue(this.$monthlyAmount, '—')
      this.applyValue(this.$benefitMonths, '—')
      this.applyValue(this.$netAmount, '—')

      return
    }

    this.$error.hide()
    this.$details.show()

    if (leaveDays === 0) {
      this.$containerWithResult.hide()
      this.$containerWithoutResult.show()
      return
    }

    // Daily Regulatory Base
    let drb = monthlyBase / 30

    // Work accident: tier 1 (day 1) = 0%, tier 2 (day 2+) = rate%
    const t1End = this.tier1End
    let days_tier2 = Math.max(0, leaveDays - t1End)
    let daily_amount_2 = this.round2(drb * this.rate)
    let result_1 = 0
    let result_2 = this.round2(daily_amount_2 * days_tier2)

    let grossSubsidy = result_2

    // fee costs: daily prorata of monthly quota, capped at N months worth of days
    const maxDaysFee = this.maxMonthsFee * 30
    const daysCharged = Math.min(leaveDays, maxDaysFee)
    let feeCosts = (monthlyFee / 30) * daysCharged

    let net = Math.max(0, grossSubsidy - feeCosts)

    let grossRounded = this.round2(grossSubsidy)
    let feeRounded = this.round2(feeCosts)
    let netRounded = this.round2(net)

    this.applyValue(this.$monthlyAmount, grossRounded)
    this.applyValue(this.$benefitMonths, feeRounded)
    this.applyValue(this.$netAmount, netRounded)

    // render detail lines
    let drbRounded = this.round2(drb)

    // Line 1: day 1 = 0€
    let days_end_1 = Math.min(leaveDays, t1End)
    this.renderLine(this.$line1, {
      '%%days_end_1%%': days_end_1,
      '%%result_1%%': result_1
    })
    this.$line1.show()

    // Line 2: day 2+ = rate%
    if (leaveDays > t1End) {
      this.renderLine(this.$line2, {
        '%%drb%%': drbRounded,
        '%%rate_2%%': Math.round(this.rate * 100) + '%',
        '%%daily_amount_2%%': daily_amount_2,
        '%%days_count_2%%': days_tier2,
        '%%days_end_2%%': leaveDays,
        '%%result_2%%': result_2
      })
      this.$line2.show()
    } else {
      this.$line2.hide()
    }

    // Line total
    this.renderLine(this.$lineTotal, {
      '%%total_days%%': leaveDays,
      '%%total%%': grossRounded
    })
    this.$lineTotal.show()
  }

  toInt(v) {
    let n = parseInt(String(v), 10)
    return Number.isFinite(n) ? n : 0
  }

  toFloat(v) {
    let n = parseFloat(String(v))
    return Number.isFinite(n) ? n : 0
  }

  round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100
  }

  applyValue($el, value) {
    if (!$el || !$el.length) return
    let template = $el.data('value') || '%%value%%'
    $el.text(String(template).replace('%%value%%', value))
  }

  renderLine($el, vars) {
    if (!$el || !$el.length) return
    let template = $el.data('template') || ''
    let text = String(template)
    for (const [key, val] of Object.entries(vars)) {
      text = text.replace(key, val)
    }
    $el.text(text)
  }
}
